import { useEffect, useState } from 'react';
import { fetchPlanningBeats, uploadBeatPlanning } from 'Service/ApiService';
import { showSuccessAlert } from 'utils/SuccessMessage';
import { useNavigate } from 'react-router-dom';
import { showAlert } from 'utils/ErrorMessage';
const BeatPlanningController = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  const [cloading, setCloading] = useState(false);
  const [beats, setBeats] = useState([]);
  const [showCalendar, setShowCalendar] = useState(false);
  const [range, setRange] = useState([
    { startDate: new Date(), endDate: new Date(), key: 'selection' }
  ]);
  const [selectedBeats, setSelectedBeats] = useState([]);
  const navigate = useNavigate();


  useEffect(() => {
    getUserBeats();
  }, []);

  const getUserBeats = async () => {
    try {
      setCloading(true);

      const response = await fetchPlanningBeats(user.userCode);

      if (response) {
        if (response.success == true) {
          setBeats(response.data);
          setCloading(false);
        }
        else {
          setBeats(response.data);
          setCloading(false);
        }
      }
      else {
        setBeats(response.data);
        setCloading(false);
      }
    } catch (error) {
      setCloading(false);
      console.error('Error fetching beats:', error);
    }
  }

  const toggleBeat = (beatCode) => {
    setSelectedBeats(prev => {
      if (prev.includes(beatCode)) {
        return prev.filter(code => code !== beatCode);
      } else {
        return [...prev, beatCode];
      }
    });
  };

  const handleSubmit = async () => {
    // 1. Validate beats
    if (selectedBeats.length === 0) {
      alert("Please select at least one beat.");
      return;
    }

    // 2. Validate date range
    const { startDate, endDate } = range[0];
    if (!startDate || !endDate) {
      alert("Please select a valid date range.");
      return;
    }
    if (startDate > endDate) {
      alert("Start date cannot be after end date.");
      return;
    }

    const dateList = getDateList(startDate, endDate);

    try {
      setCloading(true);
      console.log(selectedBeats);
      console.log(dateList);
      const response = await uploadBeatPlanning(selectedBeats, dateList, user.userCode);

      if (response) {
        if (response.success == true) {
          showSuccessAlert(response.msg);
          navigate('/beats', { state: { from: "/dashboard" } })
        } else {
          showAlert(response.msg);
        }
      }
    } catch (error) {
      setCloading(false);
      showAlert('Error uploading beats plan:', error);
    } finally {
      setCloading(false);
    }

    //     // Print selection for now
    //     console.log("Selected Beats:", selectedBeats);
    //     console.log("Selected Date Range:", startDate.toLocaleDateString(), "-", endDate.toLocaleDateString());
    //     console.log("Dates in Range:", dateList);

    // // TODO: Replace below with actual API call
    // alert(`Submitted ${selectedBeats.length} beat(s) from ${startDate.toLocaleDateString()} to ${endDate.toLocaleDateString()}`);
  };
  const getDateList = (start, end) => {
    const dates = [];
    let currentDate = new Date(start);
    while (currentDate <= end) {
      const day = String(currentDate.getDate()).padStart(2, '0');
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const year = currentDate.getFullYear();
      dates.push(`${day}/${month}/${year}`);
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates;
  };

  return {
    cloading,
    beats,
    showCalendar,
    setShowCalendar,
    selectedBeats,
    setSelectedBeats,
    range,
    setRange,
    toggleBeat,
    handleSubmit

  };
};

export default BeatPlanningController;
